/**
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2025 Pearson Education, Inc. All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 */

/**
 * @author Gladson Samuel S
 * MultiRemediationComponentStyles.js
 * Styles for multi remediation component
 */

import { styled } from '@mui/material/styles';
import mixins from '../../../assets/styles/mixins.scss';

export const AssetsContainer = styled('div')({
  '&&': {
    height: '100%',
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    '& *': {
      boxSizing: 'border-box'
    }
  }
});

export const CarouselWrapper = styled('div')({
  '&&': {
    '--card-height': '297px',
    '--card-max-width': '318px',
    '--assetsContainer-width': '318px',
    position: 'relative',
    width: '100%',
    display: 'flex',
    flexDirection: 'column',

    [mixins['md-sm-min']]: {
      '--card-height': '300px',
      '--card-max-width': '334px',
      '--assetsContainer-width': '334px'
    },
    [mixins['mlg-min']]: {
      '--card-height': '356px',
      '--card-max-width': '408px',
      '--assetsContainer-width': '408px'
    },
    [mixins['3xl-min']]: {
      '--card-max-width': '390px',
      '--assetsContainer-width': '390px'
    },

    '& .slick-list': {
      overflow: 'hidden'
    },
    '& .slick-list > .slick-track': {
      marginLeft: '0 !important',
      gap: '12px',
      display: 'flex !important',
      flexDirection: 'column',
      flexWrap: 'wrap',
      flex: '0 1 var(--card-max-width)',
      maxWidth: 'var(--assetsContainer-width)',
      maxHeight: 'var(--card-height)',
      width: 'max-content !important'
    },
    '& .slick-list > .slick-track > .slick-slide': {
      display: 'flex !important',
      width: 'var(--assetsContainer-width) !important',
      maxWidth: 'var(--assetsContainer-width) !important',
      height: 'auto'
    },
    '& .slick-list > .slick-track > .slick-slide > div': {
      width: '100%'
    },
    '& .slick-dots': {
      position: 'absolute',
      top: 'var(--slick-dots-position)',
      right: 0,
      bottom: 'auto',
      left: 'auto',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-end',
      gap: '9px',
      margin: 0,
      padding: 0,
      width: 'auto',
      height: 'auto',
      listStyle: 'none'
    },
    '& .slider-arrow-left': {
      border: `1px solid ${mixins.darkBgBorder}`,
      top: 0,
      right: '41px',
      left: 'auto',
      display: 'inline-flex !important',
      alignItems: 'center',
      justifyContent: 'center',
      '&:hover': {
        background: mixins.chalkWhiteFont
      }
    },
    '& .slider-arrow-right': {
      border: `1px solid ${mixins.darkBgBorder}`,
      top: 0,
      right: '0px',
      left: 'auto',
      display: 'inline-flex !important',
      alignItems: 'center',
      justifyContent: 'center',
      '&:hover': {
        background: mixins.chalkWhiteFont
      }
    }
  }
});
